import { Dropdown } from "antd"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function _CustomSelect(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, renderSelector, value, onChange, options } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function renderDropdown() {
        return (
            <div className="options">
                {options?.map((option) => (
                    <div
                        className="option"
                        onClick={() => onChange(option.value)}
                        key={option.value}
                    >
                        {option.label}
                    </div>
                ))}
            </div>
        )
    }

    const label = options?.find((option) => option.value === value)?.label
    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <Dropdown
                trigger="click"
                getPopupContainer={(trigger) => trigger.parentElement}
                overlay={renderDropdown()}
            >
                {renderSelector({ value, label })}
            </Dropdown>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_CustomSelect.propTypes = {
    className: PropTypes.string.isRequired,
    renderSelector: PropTypes.func,
    options: PropTypes.array,
    value: PropTypes.any,
    onChange: PropTypes.func,
}

_CustomSelect.defaultProps = {}

// ----------------------------------------------------------------------------

const CustomSelect = styled(_CustomSelect)`
    & {
        .options {
            background-color: white;
            border-radius: 6px;
            overflow: hidden;
            box-shadow: 0px 0px 12px ${({ theme }) => theme.colors.shadow};
        }
        .option {
            padding: 10px;
            cursor: pointer;
            &:hover {
                background-color: ${({ theme }) => theme.colors.dark100};
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default CustomSelect
